import axios from "axios";

// ⚠️ Apna actual backend base URL yahan confirm/update karein
const API_BASE_URL = 'https://backend.bizdevit.com/api';
// ⚠️ Agar token kisi aur jagah (Context, Redux, sessionStorage) store hota hai to yahan adjust karein
const getToken = () => localStorage.getItem("doctor_token");

export const fetchTherapyHistory = async (status = "total") => {
  const response = await axios.get(`${API_BASE_URL}/doctor/TherapyHistory/list`, {
    params: { status },
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  return response.data; // { success, stats, data: { data: [...], current_page, ... } }
};